import type { ParameterDefinitionCreateOperation } from '@festina/configuration-general-types/configuration'
import { assertNotEmpty, dateUtils, type Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { DocumentationEntry } from '../../../components/documentationEntry/DocumentationEntry'
import { EditableMarkdownViewer } from '../../../components/markdownEditor/EditableMarkdownViewer'
import { useParameterContext } from '../../../context/parameterContext'
import { useOperationsContext } from '../../../workspace/operationsContext'

export const ParameterDefinitionDetails = () => {
  const translate = useTranslate()
  const { parameterDefinitionOperation } = useParameterContext()
  const { onAddOrUpdateOperation } = useOperationsContext()
  assertNotEmpty(parameterDefinitionOperation)

  const { isDraft, internalOperation } = parameterDefinitionOperation

  const handleUpdateDescription = async (nextValue: Optional<string>) => {
    const nextOperation = {
      ...internalOperation,
      entity: {
        _type: 'ParameterDefinitionInOut',
        ...internalOperation.entity,
        description: nextValue ?? undefined,
      },
    } satisfies ParameterDefinitionCreateOperation

    await onAddOrUpdateOperation({
      operation: nextOperation,
      layer: parameterDefinitionOperation.layer,
      block: parameterDefinitionOperation.block,
      // Irrelevant. You can only edit the description of a draft, which can only exist in the workspace.
      shouldOpenUnifiedBranchWorkspace: false,
    })
  }

  const description = internalOperation.entity?.description

  return (
    <>
      <DocumentationEntry
        title={translate('parameterViewer.parameterDetails.startDate')}
        value={dateUtils.dateAsStr(internalOperation.entity?.fromDate)}
      />
      <DocumentationEntry
        title={translate('parameterViewer.parameterDetails.description')}
        value={
          <EditableMarkdownViewer
            key={description}
            value={description}
            onSave={isDraft ? handleUpdateDescription : undefined}
          />
        }
      />
    </>
  )
}
